import Button from '../Button';
import { useWithAccess } from '@hooks';
import { MoreActions } from '../MoreActions';
import type { ActionType } from '../MoreActions';

type ButtonsProps = {
  size?: ActionType['size'];
  variant?: ActionType['variant'];
  buttons: Array<ActionType | Falsy>;
  visibleCount?: number;
};

const Buttons: React.FC<ButtonsProps> = props => {
  const { size = 'md', variant = 'icon', buttons, visibleCount = 3 } = props;

  const moreButtons = useWithAccess(
    [...buttons].filter(b => typeof b === 'object' && !!b)
  );
  const visibleButtons = moreButtons.splice(0, visibleCount).filter(Boolean);

  return (
    <div className="flex flex-row items-center gap-md justify-end">
      {visibleButtons.map((button, index) => (
        <Button
          key={index}
          {...button}
          size={size}
          variant={variant}
          label={undefined}
          className="shadow-none"
        />
      ))}
      {!!moreButtons.length && (
        <MoreActions buttons={moreButtons} buttonProps={{ variant, size }} />
      )}
    </div>
  );
};

export default Buttons;
